import { Box, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { FaPhone } from 'react-icons/fa';

import getSearchPhoneNumbers from '../../../../utils/getSearchPhoneNumbers';

const HaveQuestionsCTA = () => {
  const phone = getSearchPhoneNumbers();

  return (
    <Flex
      display={{ base: 'none', md: 'flex' }}
      align="center"
      gap={3}
      position="fixed"
      zIndex="sticky"
      bottom={0}
      right={0}
      w="fit-content"
      bg="grayBackground"
      pr={6}
      pl={10}
      py={4}
      roundedTopLeft="99px"
      borderTop="2px solid"
      borderLeft="2px solid"
      borderColor="leaseEndBlue"
      boxShadow="0 -3px 12px rgba(0,0,0,0.08)"
    >
      <Icon as={FaPhone} color="leaseEndBlue" boxSize="24px" transform="rotate(90deg)" />
      <Box>
        <Text fontWeight="bold" fontSize="md" color="leaseEndBlue">
          HAVE QUESTIONS?
        </Text>
        <Text fontSize="sm" color="gray.600">
          Give us a ring at{' '}
          <Link href={`tel:+1-${phone}`} fontWeight="semibold">
            {phone}
          </Link>
        </Text>
      </Box>
    </Flex>
  );
};

export default HaveQuestionsCTA;
